import React, { useState } from 'react';
import theme, { getTheme } from '../../theme';
import { useDarkMode } from '../../context/DarkModeContext';

export default function Input({ label, error, style, id, floating = true, value, defaultValue, onChange, ...rest }) {
  const [focused, setFocused] = useState(false);
  const { isDark } = useDarkMode();
  const t = getTheme(isDark);
  const inputId = id || rest.name || label;
  const hasValue = value !== undefined ? String(value).length > 0 : false;
  const floated = floating && (focused || hasValue);

  if (!floating || !label) {
    return (
      <div style={{ width: '100%' }}>
        {label && (
          <label htmlFor={inputId} style={{ display: 'block', fontSize: 11, fontWeight: 600, color: t.textSec, marginBottom: '6px' }}>
            {label}
          </label>
        )}
        <input
          id={inputId}
          value={value}
          onChange={onChange}
          onFocus={(e) => { setFocused(true); rest.onFocus?.(e); }}
          onBlur={(e) => { setFocused(false); rest.onBlur?.(e); }}
          style={{
            width: '100%', minHeight: '44px', padding: '0 14px',
            fontSize: '14px', fontFamily: theme.fontBody, color: t.text,
            background: t.surface2,
            border: `1px solid ${error ? t.red : focused ? t.gold : t.border2}`,
            borderRadius: theme.r2, outline: 'none', boxSizing: 'border-box',
            transition: 'all 0.15s',
            boxShadow: focused ? theme.focusRing : 'none',
            ...style,
          }}
          {...rest}
        />
        {error && <div style={{ fontSize: 11, color: t.red, marginTop: '5px' }}>{error}</div>}
      </div>
    );
  }

  return (
    <div style={{ width: '100%', position: 'relative' }}>
      <input
        id={inputId}
        value={value}
        onChange={onChange}
        onFocus={(e) => { setFocused(true); rest.onFocus?.(e); }}
        onBlur={(e) => { setFocused(false); rest.onBlur?.(e); }}
        placeholder={focused ? rest.placeholder || '' : ''}
        style={{
          width: '100%', height: '52px', padding: floated ? '20px 14px 6px' : '0 14px',
          fontSize: '14px', fontFamily: theme.fontBody, color: t.text,
          background: t.surface2,
          border: `1px solid ${error ? t.red : focused ? t.gold : t.border2}`,
          borderRadius: theme.r2, outline: 'none', boxSizing: 'border-box',
          transition: 'all 0.15s',
          boxShadow: focused ? theme.focusRing : 'none',
          ...style,
        }}
        {...rest}
        placeholder={focused ? (rest.placeholder || '') : ''}
      />
      <label
        htmlFor={inputId}
        style={{
          position: 'absolute', left: '14px', pointerEvents: 'none',
          transition: 'all 0.15s ease',
          top: floated ? '8px' : '50%',
          transform: floated ? 'none' : 'translateY(-50%)',
          fontSize: floated ? 10 : '14px',
          fontWeight: floated ? 600 : 400,
          color: focused ? t.gold : t.textTert,
        }}
      >
        {label}
      </label>
      {error && <div style={{ fontSize: 11, color: t.red, marginTop: '5px' }}>{error}</div>}
    </div>
  );
}
